import AnalyticsService from '@emcd-shared/analytics-service'
import cookies from 'vue-cookies'
import router from '@/app/router'
import store from '@/app/store'
import i18n from '@/app/i18n'

const PAGE_NAME_BY_PATH_PREFIX = [
  ['/profile/security', 'security'],
  ['/profile/account-center', 'account_center'],
  ['/profile/preferences', 'preferences'],
  ['/profile/confirm', 'profile'],
  ['/profile', 'profile'],
  ['/invoices', 'invoices'],
  ['/mass-payments', 'mass_payments'],
  ['/earn-on-swap', 'earn_on_swap'],
  ['/payment-links', 'payment_links'],
  ['/api-and-integrations', 'api_and_integrations'],
  ['/wallet', 'wallet'],
  ['/auth', 'auth'],
  ['/authorizer', 'auth'],
]

const SegmentService = {
  getYid() {
    return cookies.get('_ym_uid') || 'undefined'
  },
  get_Ga() {
    return cookies.get('_ga') || 'undefined'
  },
  getGaIdNumber() {
    return cookies.get(process.env.VUE_APP_GA_ID_NUMBER) || 'undefined'
  },
  getPageName() {
    const path = router.currentRoute.value.path || '/'
    for (const [prefix, name] of PAGE_NAME_BY_PATH_PREFIX) {
      if (path === prefix || path.startsWith(`${prefix}/`)) return name
    }
    const firstSegment = path.split('/').filter(Boolean)[0]
    return firstSegment ? firstSegment.replace(/-/g, '_') : 'unknown'
  },
  getSegmentData() {
    const route = router.currentRoute.value
    const segmentId = store.state.auth.user?.segment_id || 'undefined'
    return {
      product: 'b2b_account',
      segment_id: segmentId,
      lang: i18n.global.locale.value,
      url: window.location.href,
      yid: this.getYid(),
      _ga: this.get_Ga(),
      [process.env.VUE_APP_GA_ID_NUMBER]: this.getGaIdNumber(),
      utm_campaign: route.query.utm_campaign,
      utm_content: route.query.utm_content,
      utm_medium: route.query.utm_medium,
      utm_source: route.query.utm_source,
      utm_term: route.query.utm_term,
    }
  },
  trackNewEvent(eventType, data) {
    const payload = {
      ...this.getSegmentData(),
      ...data,
    }
    AnalyticsService.track(eventType, payload)
  },
}

export default SegmentService
